module.exports = __webpack_public_path__ + "static/media/Logo_720.6b441db8.png";